import { EuiFlexGroup, EuiFlexItem, EuiSwitch, EuiFacetButton,EuiBadge } from "@elastic/eui"
import { useEffect, useMemo } from "react";

export const MenuLista = (props:any) =>{

    const {onChange, checkAll, itemsNumber, itemsSelection} = props;

    console.log('props MenuLista ', props)

    const Label = useMemo(()=> (checkAll===true) ? "Desmarcar Todos" : "Marcar Todos",[checkAll])

    const onCheckChange = (value:boolean) =>{
        onChange(value)
    }

    return (
        <EuiFlexGroup id="menu-lista-centros">
            <EuiFlexGroup>
                <EuiFlexItem>
                    <EuiSwitch label={Label} checked={(checkAll===undefined ? false : checkAll)} onChange={()=> onCheckChange(((checkAll===undefined || checkAll===false) ? true : false))}/>
                </EuiFlexItem>
            </EuiFlexGroup>
            <EuiFlexGroup style={{justifyContent: "flex-end"}}>
                <EuiFlexItem grow={false}>
                    <EuiFlexGroup>
                        <EuiFlexItem className="literal" grow={false}>{`Nº de centros`}</EuiFlexItem>
                        <EuiFlexItem grow={false}><EuiBadge color="primary">{itemsNumber}</EuiBadge></EuiFlexItem>
                    {/* <EuiFacetButton quantity={itemsNumber} isSelected={false}>{`Nº de centros`}</EuiFacetButton> */}
                    </EuiFlexGroup>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiFlexGroup>
                        <EuiFlexItem className="literal" grow={false}>{`Sin Marcar`}</EuiFlexItem>
                        <EuiFlexItem grow={false}><EuiBadge color="default">{itemsNumber - itemsSelection}</EuiBadge></EuiFlexItem>
                    </EuiFlexGroup>
                    {/* <EuiFacetButton quantity={itemsNumber - itemsSelection} isSelected={false}>{`Sin Marcar`}</EuiFacetButton> */}
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiFlexGroup>
                        <EuiFlexItem className="literal" grow={false}>{`Marcados`}</EuiFlexItem>
                        <EuiFlexItem grow={false}><EuiBadge color="secondary">{itemsSelection}</EuiBadge></EuiFlexItem>
                    </EuiFlexGroup>
                    {/* <EuiFacetButton quantity={itemsSelection} isSelected={false}>{`Marcados`}</EuiFacetButton> */}
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiFlexGroup>
    )
}